// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UBLY","comment":"styles_comment__3-dd0"};